import http from '@/communication/AuthConnection'

export default async ({ commit, state }, { searchString }) => {
  const actualPage = state.actualPage
  const offsetPage = state.offsetPage

  const params = {
    actualPage,
    offsetPage,
    searchString
  }

  try {
    const { data } = await http.get('/v1/stock/paginated-fat-search', params)
    return data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/record/stock/PaginatedFatSearch.js